import { CONSENT_URL } from 'src/config/api.config';
import ApiService from './Api.service';

class ConsentService extends ApiService {
  constructor() {
    super(CONSENT_URL);
  }

  /**
   * Create consent record (supports authenticated users or public signup/first-login with userId in body)
   * POST /consents
   */
  createConsent = async (payload = {}, headers = {}) => {
    return this.post(payload, null, headers);
  };

  /**
   * Get current user's consent status (checks if current user has already consented)
   * GET /consents/my-consent
   */
  getMyConsent = async (params = {}, headers = {}) => {
    return this.doGet(`${CONSENT_URL}/my-consent`, params, {
      ...this._headers,
      ...headers
    });
  };

  /**
   * Withdraw consent (from Privacy Settings modal/page)
   * POST /consents/withdraw or POST /consents/:consentId/withdraw
   */
  withdrawConsent = async (consentIdOrPayload = {}, payload = {}, headers = {}) => {
    if (typeof consentIdOrPayload === 'string' || typeof consentIdOrPayload === 'number') {
      return this.doPost(`${CONSENT_URL}/${consentIdOrPayload}/withdraw`, payload, null, {
        ...this._headers,
        ...headers
      });
    }
    return this.doPost(`${CONSENT_URL}/withdraw`, consentIdOrPayload, null, {
      ...this._headers,
      ...headers
    });
  };

  /**
   * Export sample consent records for DPDP audit compliance (Aegisra submission)
   * GET /consents/samples
   */
  getSampleConsents = async (params = {}, headers = {}) => {
    return this.doGet(`${CONSENT_URL}/samples`, params, {
      ...this._headers,
      ...headers
    });
  };

  /**
   * Query all consents (with filters, pagination, sorting)
   * GET /consents
   */
  getConsents = async (params = {}, headers = {}) => {
    return this.get(params, headers);
  };

  /**
   * Get single consent by ID
   * GET /consents/:consentId
   */
  getConsentById = async (consentId, params = {}, headers = {}) => {
    return this.getById(consentId, params, headers);
  };

  /**
   * Update consent record (e.g. modify purpose preferences)
   * PUT /consents/:consentId
   */
  updateConsent = async (consentId, payload = {}, headers = {}) => {
    return this.put(consentId, payload, null, headers);
  };

  /**
   * Partial update consent record
   * PATCH /consents/:consentId
   */
  patchConsent = async (consentId, payload = {}, headers = {}) => {
    return this.patch(consentId, payload, null, headers);
  };
}

export default new ConsentService();
